<template>
    <el-dialog :title="title" :visible="showDialog" @close="close" width="45%">
        <div class="row">
            <div class="col-md-12">
                <label>Salón</label>
                <el-select v-model="form.restaurant_room_id" filterable>
                    <el-option
                        v-for="option in rooms"
                        :key="option.id"
                        :label="option.name"
                        :value="option.id">
                    </el-option>
                </el-select>
            </div>

            <div class="col-md-6 mt-3">
                <label>Nombre de mesa</label>
                <el-input v-model="form.name"></el-input>
            </div>

            <div class="col-md-6 mt-3">
                <label>Capacidad</label>
                <el-input-number v-model="form.capacity" :min="1"></el-input-number>
            </div>

            <div class="col-md-6 mt-3">
                <label>Estado operativo</label>
                <el-select v-model="form.status">
                    <el-option
                        v-for="option in statuses"
                        :key="option.id"
                        :label="option.description"
                        :value="option.id">
                    </el-option>
                </el-select>
            </div>

            <div class="col-md-6 mt-4">
                <el-switch v-model="form.active" active-text="Activo" inactive-text="Inactivo"></el-switch>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="close">Cancelar</el-button>
            <el-button type="primary" @click="submit">Guardar</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: ['showDialog', 'record'],
    data() {
        return {
            resource: 'restaurant/v2/dining-tables',
            form: {},
            rooms: [],
            statuses: [],
        }
    },
    computed: {
        title() {
            return this.form.id ? 'Editar mesa' : 'Nueva mesa'
        },
    },
    watch: {
        showDialog(value) {
            if (value) {
                this.initForm()
                this.getTables()
            }
        },
    },
    methods: {
        initForm() {
            this.form = this.record
                ? Object.assign({}, this.record)
                : {
                    id: null,
                    restaurant_room_id: null,
                    name: null,
                    capacity: 1,
                    status: 'available',
                    active: true,
                }
        },
        getTables() {
            this.$http.get(`/${this.resource}/tables`).then(response => {
                this.rooms = response.data.rooms
                this.statuses = response.data.statuses
            })
        },
        close() {
            this.$emit('update:showDialog', false)
        },
        submit() {
            this.$http.post(`/${this.resource}`, this.form).then(response => {
                this.$message.success(response.data.message)
                this.$emit('saved')
                this.close()
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// modules/Restaurant/Resources/assets/js/views/v2/dining_tables/form.vue